(function ($, XTT) {
	'use strict';

	XTT.header = {

		_autoload: [
			'bindHeaderEvents',
			'handleFixedHeader'
		],

		bindHeaderEvents: function() {
			XTT.header.$isMobile = $(window).width() <= 768;
			XTT.header.$searchForm = $('.mini-nav__search-form');
			XTT.header.$searchFormTrigger = $('.mini-nav__search');

			$(window).on('resize', function() {
				XTT.header.$isMobile = $(window).width() <= 768;
			});

			XTT.header.$searchFormTrigger.on('click', XTT.header.handleSearchVisibility);
			$('.menu-item-has-children').hover(XTT.header.handleSubmenuVisibilityDesktop);
			$('.menu-item-has-children > a').on('click', XTT.header.handleSubmenuVisibilityMobile);
			$('.main-nav__mobile-nav').on('click', XTT.header.handleMobileNavOpen);
			$('.main-nav__mobile-close').on('click', XTT.header.handleMobileNavClose);
			$('.main-nav__mobile-search').on('click', XTT.header.handleSearchVisibility);
			$('.mini-nav__search-close').on('click', XTT.header.handleSearchVisibility);
		},

		handleFixedHeader: function() {
			
			var $window = $(window),
			    $body = $('body'),
			    $header = $('.header'),
    			lastY = $window.scrollTop();
    
			$window.on('scroll', function() {
    		var currY = $window.scrollTop(),
      	direction = (currY > lastY) ? 'down' : ((currY === lastY) ? 'none' : 'up');
      	if(currY > 0) {
      		$body.addClass('scrolling');
      		XTT.header.$searchForm.removeClass('open');
      		XTT.header.$searchFormTrigger.removeClass('open');
      	} else {
      		$body.removeClass('scrolling');
      	}
    		if(direction === "up" && currY > $header.height()) {
    			$body.addClass('fixed-header');
    		} else {
    			$body.removeClass('fixed-header');
    		}
		    lastY = currY;
			});
		},

		handleSearchVisibility: function (e) {
			$(this).toggleClass('open');
			XTT.header.$searchForm.toggleClass('open');
			XTT.header.$searchForm.find('input[type="text"]').focus();
			e.preventDefault();
		},

		handleSubmenuVisibilityDesktop: function() {
			if(!XTT.header.$isMobile) {
				$(this).find('ul').toggleClass('open');
			}
		},

		handleSubmenuVisibilityMobile: function(e) {
			if(XTT.header.$isMobile) {
				$(this).next('ul').toggleClass('open');
				$(this).toggleClass('subnav-open');
				e.preventDefault();
			}
		},

		handleMobileNavOpen: function(e) {
			e.preventDefault();
			$('body').addClass('nav-open');
		},

		handleMobileNavClose: function(e) {
			e.preventDefault();
			$('body').removeClass('nav-open');
		}

	};

})
(jQuery, XTT);